import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import H3 from 'UIComponents/elements/headings/H3';
import UIFlex from 'UIComponents/layout/UIFlex';

const InnerSectionHeading = ({
  children,
  className = 'm-bottom-4',
  itemRight
}) => {
  if (itemRight) {
    return /*#__PURE__*/_jsxs(UIFlex, {
      className: className,
      justify: "between",
      align: "center",
      wrap: "wrap",
      children: [/*#__PURE__*/_jsx(H3, {
        className: "m-bottom-0",
        children: children
      }), itemRight]
    });
  }

  return /*#__PURE__*/_jsx(H3, {
    className: className,
    children: children
  });
};
/**
 * @deprecated use marketplace-ui-common
 */


export default InnerSectionHeading;